module.exports = __webpack_public_path__ + "static/team-bbf9f0ea0c284ebba53fc0d064aec80f.svg";